import React from 'react'

import { Size } from '@/types/size'

type UserProps = {
  size: Size
}
const User = ({ size }: UserProps) => (
  <svg
    width={size.width}
    height={size.height}
    viewBox="0 0 36 36"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="profile-photo">
        <rect id="Rectangle" fill="transparent" x="0" y="0" width="36" height="36" />
        <path
          d="M26,24.0625 L26,24.6850586 C26,24.7729497 25.9694827,24.8474118 25.9084473,24.9084473 C25.8474118,24.9694827 25.7729497,25 25.6850586,25 L11.3149414,25 C11.2270503,25 11.1525882,24.9694827 11.0915527,24.9084473 C11.0305173,24.8474118 11,24.7729497 11,24.6850586 L11,24.0625 C11,23.6376932 11.1037587,23.2617204 11.3112793,22.9345703 C11.5187999,22.6074202 11.7873519,22.3413096 12.1169434,22.1362305 C12.4465349,21.9311513 12.8115214,21.7443856 13.2119141,21.5759277 C13.6123067,21.4074699 14.0126933,21.2463387 14.4130859,21.0925293 C14.8134786,20.9387199 15.1784651,20.776368 15.5080566,20.6054688 C15.8376481,20.4345695 16.1062001,20.2185072 16.3137207,19.9572754 C16.5212413,19.6960436 16.625,19.3969743 16.625,19.0600586 C16.5761716,19.0112302 16.5090336,18.9367681 16.423584,18.8366699 C16.3381343,18.7365718 16.1879894,18.5168474 15.9731445,18.1774902 C15.7582997,17.8381331 15.5678719,17.4792499 15.4018555,17.1008301 C15.235839,16.7224102 15.085694,16.2292511 14.951416,15.6213379 C14.817138,15.0134247 14.75,14.3896516 14.75,13.75 C14.75,13.242185 14.848876,12.7575707 15.0466309,12.2961426 C15.2443858,11.8347145 15.5117171,11.4355486 15.8486328,11.0986328 C16.1855486,10.7617171 16.5847145,10.4943858 17.0461426,10.2966309 C17.5075707,10.098876 17.992185,10 18.5,10 C19.007815,10 19.4924293,10.098876 19.9538574,10.2966309 C20.4152855,10.4943858 20.8144514,10.7617171 21.1513672,11.0986328 C21.4882829,11.4355486 21.7556142,11.8347145 21.9533691,12.2961426 C22.151124,12.7575707 22.25,13.242185 22.25,13.75 C22.25,14.2187523 22.2158207,14.6765114 22.1474609,15.123291 C22.0791012,15.5700706 21.9899908,15.9643538 21.880127,16.3061523 C21.7702631,16.6479509 21.648194,16.971434 21.513916,17.2766113 C21.379638,17.5817886 21.245362,17.8405751 21.111084,18.0529785 C20.976806,18.2653819 20.8547369,18.4497062 20.744873,18.605957 C20.6350092,18.7622078 20.5458988,18.8769528 20.4775391,18.9501953 L20.375,19.0600586 C20.375,19.3969743 20.4787587,19.6960436 20.6862793,19.9572754 C20.8937999,20.2185072 21.1623519,20.4345695 21.4919434,20.6054688 C21.8215349,20.776368 22.1865214,20.9387199 22.5869141,21.0925293 C22.9873067,21.2463387 23.3876933,21.4074699 23.7880859,21.5759277 C24.1884786,21.7443856 24.5534651,21.9311513 24.8830566,22.1362305 C25.2126481,22.3413096 25.4812001,22.6074202 25.6887207,22.9345703 C25.8962413,23.2617204 26,23.6376932 26,24.0625 Z"
          id="user"
          fill="#FFFFFF"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
)

User.defaultProps = {
  size: {
    width: 36,
    height: 36,
  },
}

export default User
